// ═══════════════════════════════════════════════════════════════════════════════
//  src/components/assessment/assessmentApi.js
//  MICROSERVICIO ENGLISH ASSESSMENT — capa de datos
//
//  Habla únicamente con /api/v3/assessment. Todas las rutas exigen sesión de
//  alumno: presentar el examen es gratis, pero no anónimo.
//
//  ⚠️  El navegador NUNCA recibe la clave de respuesta. El servidor sirve un
//      reactivo a la vez y califica él. Esta capa solo transporta.
// ═══════════════════════════════════════════════════════════════════════════════

const BASE = `${import.meta.env.VITE_API_URL || ''}/api/v3/assessment`;

function authHeaders() {
  const token = localStorage.getItem('token');
  return {
    'Content-Type': 'application/json',
    ...(token ? { Authorization: `Bearer ${token}` } : {}),
  };
}

async function request(path, options = {}) {
  const res = await fetch(`${BASE}${path}`, { headers: authHeaders(), ...options });

  if (!res.ok) {
    let detail = 'No pudimos conectar con la evaluación.';
    try {
      const body = await res.json();
      if (body?.detail) detail = body.detail;
    } catch {
      // Respuesta sin JSON: se queda el mensaje genérico.
    }
    const err = new Error(detail);
    err.status = res.status;
    throw err;
  }

  return res.json();
}

/** ¿Ya midió su condición? ¿Puede ver resultados? */
export function getStatus() {
  return request('/status');
}

/**
 * Inicia o retoma la evaluación.
 * @param {{entry_level?:string, onboarding_session_id?:string}} opts
 */
export function startAssessment(opts = {}) {
  const body = {};
  if (opts.entryLevel) body.entry_level = opts.entryLevel;
  if (opts.onboardingSessionId) body.onboarding_session_id = opts.onboardingSessionId;
  return request('/start', { method: 'POST', body: JSON.stringify(body) });
}

/** Envía una respuesta y recibe el siguiente reactivo (o el resultado). */
export function submitAnswer({ sessionId, itemId, response, timeMs }) {
  return request('/answer', {
    method: 'POST',
    body: JSON.stringify({
      session_id: sessionId,
      item_id: itemId,
      response,
      time_ms: Math.max(0, Math.min(600_000, Math.round(timeMs || 0))),
    }),
  });
}

/** La radiografía. Devuelve `locked: true` si el plan no la cubre. */
export function getResult(sessionId) {
  return request(`/result/${sessionId}`);
}

/** Perfil consolidado por skill — el que después leerá el tutor. */
export function getSkillProfile() {
  return request('/profile/me');
}
